// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./local_static/templates/quadro_de_medalhas/2018/assets/styles/main.scss
// module id = 333
// module chunks = 0